import { Form } from "antd";
import React, { useEffect, useState } from "react";
import Button from "components/BaseWidgets/button";
import OtpInput from "components/BaseWidgets/form/otp";
import { useLoginWithOtp, useOtpVerification } from "hooks/api/useAuth";
import { requestForToken } from "../../../firebase/firebase";

const Otp = ({ setRender, phoneNumber, countryCode }) => {
  const [otpValue, setOtpValue] = useState("");
  const [form] = Form.useForm();
  const [counter, setCounter] = useState(130);
  const [fcmToken, setFcmToken] = useState(null);
  const { mutate: otp, isPending } = useOtpVerification();
  const { mutate: requestOtp, isPending: isResendPending } = useLoginWithOtp();

  useEffect(() => {
    const fetchToken = async () => {
      const token = await requestForToken();
      setFcmToken(token);
    };
    fetchToken();
  }, []);

  const onFinish = (values) => {
    if (otpValue.length < 6) {
      form.setFields([
        {
          name: "otp",
          errors: ["Please enter the complete 6-digits OTP"],
        },
      ]);
      return;
    }
    const payload = {
      identifier: phoneNumber,
      code: values.otp,
      fcmToken,
    };

    if (countryCode) {
      payload.countrycode = countryCode?.value;
    }

    otp({
      payload,
      fcmToken,
    });
  };

  useEffect(() => {
    const timer =
      counter > 0 &&
      setInterval(() => {
        setCounter((prev) => prev - 1);
      }, 1000);

    return () => clearInterval(timer);
  }, [counter]);

  const formatTime = () => {
    const minutes = Math.floor(counter / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (counter % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const handleResend = () => {
    const payload = {
      identifier: phoneNumber,
    };

    if (countryCode) {
      payload.countrycode = countryCode?.value;
    }

    requestOtp(payload);
    setCounter(130);
  };

  return (
    <>
      <Button isBack onClick={() => setRender(false)}></Button>
      <div className="page-heading">
        <h2 className="title font-title-xl mb-2">OTP verification</h2>
        <div className="otp-info-line">
          <p className="subtitle user-identifier font-body-xs">
            Enter OTP send to{" "}
            <span className="identifier">{`${countryCode ? countryCode?.label : ""} ${phoneNumber}`}</span>
          </p>
          <Button
            onClick={() => setRender(false)}
            className={"change-link"}
            variant="link"
          >
            {" "}
            Change
          </Button>
        </div>
      </div>

      <div className="auth-form-container">
        <Form
          form={form}
          className="login-form"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            name="otp"
            validateTrigger="onSubmit"
            className="custom-error"
            rules={[
              {
                validator: (_, value) => {
                  if (
                    !value ||
                    value.length !== 6 ||
                    [...value].some((digit) => digit === "")
                  ) {
                    return Promise.reject(
                      new Error("Please enter the complete 6-digits OTP"),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <OtpInput
              id="otp"
              mask="•"
              variant="outlined"
              placeholder={"-".repeat(length)}
              value={otpValue}
              setValue={setOtpValue}
            />
          </Form.Item>
          <p className="otp-timer mt-4 text-sm text-primary">
            {counter > 0 ? (
              <>
                Resend the OTP in: <span className="timer">{formatTime()}</span>
              </>
            ) : (
              <Button
                className="change-link"
                variant="link"
                onClick={handleResend}
                isLoading={isResendPending}
              >
                Resend
              </Button>
            )}
          </p>
          <Button
            htmlType="submit"
            isLoading={isPending}
            className={"mt-8 mb-6"}
            wFull
          >
            Submit
          </Button>
        </Form>
      </div>
    </>
  );
};

export default Otp;
